"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentTimeQuora = void 0;
const utils_1 = require("../utils");
function getCurrentTimeQuora(targetTime) {
    //Quora uses PST timezone, so we take the current time, but convert it to PST
    // const currentTimeLocally = new Date('11/12/2024, 8:20:00 AM');
    const currentTimeLocally = targetTime || new Date();
    let dateString;
    let day, month, year, hour, minute, second;
    if (targetTime) {
        //if we already have a target time based on the timezone of the server, we should just use the given date and convert it
        //to the equivalent timestring and ignore timezones
        //format: 04/11/2024, 16:00:00
        // dateString = currentTimeLocally.getDate().toString().padStart(2, '0') + '/' + (currentTimeLocally.getMonth() + 1).toString().padStart(2, '0') + '/' + currentTimeLocally.getFullYear() + ', ' + currentTimeLocally.getHours().toString().padStart(2, '0') + ':' + currentTimeLocally.getMinutes().toString().padStart(2, '0') + ':' + currentTimeLocally.getSeconds().toString().padStart(2, '0');
        dateString = currentTimeLocally.toISOString();
        [year, month, day] = dateString.split('T')[0].split('-');
        [hour, minute, second] = dateString.split('T')[1].split(':');
        second = second.replace('Z', '');
        day = parseInt(day);
        month = parseInt(month);
        year = parseInt(year);
        hour = parseInt(hour);
        minute = parseInt(minute);
        second = parseInt(second);
    }
    else {
        dateString = currentTimeLocally.toLocaleString("en-GB", {
            timeZone: "America/Los_Angeles"
        });
        // dateString = '11/12/2024, 1:20:00 AM'; //for example
        //8/16/2024, 6:49:52 AM
        //get the year,month,day,hour,minute,second from quoara date string with a regex
        const dateRegex = /(\d{1,2})\/(\d{1,2})\/(\d{4}), (\d{1,2}):(\d{1,2}):(\d{1,2})/;
        const match = dateString.match(dateRegex);
        if (!match) {
            throw new Error("Could not find date in quora date string");
        }
        day = parseInt(match[1]);
        month = parseInt(match[2]);
        year = parseInt(match[3]);
        hour = parseInt(match[4]);
        minute = parseInt(match[5]);
        second = parseInt(match[6]);
    }
    //temporary code to add offset of 0 hours (based on observations) but still use time based on region
    // const manualOffsetHours = 0;
    //adjust based on offset
    //if we created a negative hour
    const originalTime = { second, minute, hour, day, month, year };
    // adjustTime(originalTime,manualOffsetHours);
    //update the datestring with the right hour after the offset
    // dateString = `${zeroPad(originalTime.month,2)}/${zeroPad(originalTime.day,2)}/${originalTime.year}, ${zeroPad(originalTime.hour,2)}:${zeroPad(originalTime.minute,2)}:${zeroPad(originalTime.second,2)}`;
    //in observations, we found that data changes until around 00:27
    //so at 0:20 we will do the last run of the previous day
    const isLastRun = originalTime.hour == 0 && originalTime.minute >= 20 && originalTime.minute < 40;
    //and at 0:40 we will do the first run of the new day
    const isFirstRun = originalTime.hour == 0 && originalTime.minute >= 40 && originalTime.minute < 60;
    //we construct an object from which we determine the right date for the api calls
    const apiTargetDateObject = { ...originalTime };
    //now we now the target date for the api call
    let targetDate = apiTargetDateObject.year + '-' + (0, utils_1.zeroPad)(apiTargetDateObject.month, 2) + '-' + (0, utils_1.zeroPad)(apiTargetDateObject.day, 2);
    let adjustedTargetDate = targetDate;
    //since quoras daily numbers keep updating until 0:20, for the run 00:00 and 00:20 we will query the previous day20
    if (hour === 0 && minute <= 20) {
        //adjust the time to yesterday for the api call (but remember the actual original time in quoras timezone)
        // console.log(`At ${zeroPad(originalTime.hour,2)}:${zeroPad(originalTime.minute,2)} - Getting data for yesterday: ${zeroPad(apiTargetDateObject.year,2) + '-' + zeroPad(apiTargetDateObject.month,2) + '-' + zeroPad(apiTargetDateObject.day,2)}`);
        let adjustedDate = new Date(targetDate + 'T23:59:59.999Z');
        adjustedDate.setDate(adjustedDate.getDate() - 1);
        adjustedTargetDate = adjustedDate.toISOString().split('T')[0];
    }
    const tomorrow = new Date(adjustedTargetDate);
    tomorrow.setDate(tomorrow.getDate() + 1);
    const nextDate = tomorrow.toISOString().split('T')[0];
    const yesterday = new Date(adjustedTargetDate);
    yesterday.setDate(yesterday.getDate() - 1);
    const previousDate = yesterday.toISOString().split('T')[0];
    let observationTag;
    let observationDate;
    let quoraTimeFakeISO;
    // if(targetTime) {
    //   //if we target a given date, it will be like 1 dec 00:00, incidcating we want to get data from 1 dec
    //   //But actually we want the totals for the whole of 1 dec, so the observation date should be 2 dec 00:00
    //   //Hence we add 1 day to the target date
    //   observationDate = targetTime;
    //   observationDate.setDate(observationDate.getDate() + 1);
    //   quoraTimeFakeISO = observationDate;
    // } else {
    //NOTE: quora updates the data of today UNTIL 0:20 the next day
    //AT 0:20 the data of the previous day is complete
    //AT 0:27 the data of the new day is starting to come in
    //So to make sure our timestamps correctly reflect the right day, we save the timestamp as 20 minutes before the current quora time
    //This means that at 0:20, the observation date is still the previous day
    //And at 0:40, we will store the first data under 0:20 of the new day
    //SUMMARY: the observation date is 20 minutes before the current time
    //ALSO, we store quora times in the graph, with a Z. So we're pretending quora time is ISO time
    //therefor we need to create a 'Z' time string
    let observationTimestring = (0, utils_1.zeroPad)(originalTime.hour, 2) + ':' + (0, utils_1.zeroPad)(originalTime.minute, 2) + ':' + (0, utils_1.zeroPad)(originalTime.second, 2);
    observationDate = new Date(targetDate + 'T' + observationTimestring + 'Z');
    //02:00 in quora... then its actually 10:00 in UTC
    //but quoraTimeFakeISO will be '2024-12-01:02:00:00Z'
    quoraTimeFakeISO = new Date(targetDate + 'T' + observationTimestring + 'Z');
    // observationDate = new Date(quoraDateCorrectNumbers);
    observationDate.setMinutes(observationDate.getMinutes() - 20);
    if (isLastRun) {
        //if it is the last run of the day, we store the observation date as the end of the day
        observationDate = new Date(adjustedTargetDate + 'T23:59:59.999Z');
        observationTag = 'dailyTotal';
    }
    // }
    return {
        ...originalTime,
        previousDate,
        targetDate: adjustedTargetDate,
        nextDate,
        isFirstRun,
        isLastRun,
        observationDate,
        quoraTimeFakeISO,
        observationTag
    };
}
exports.getCurrentTimeQuora = getCurrentTimeQuora;
//# sourceMappingURL=quora-time.js.map